import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { PasswordValidation } from './password-validation.interface';
import { BackEndVerificationToken, VerificationToken } from './verification-token';
import { ContentType } from '../../../enums/content-type.enum';
import { HeaderKey } from '../../../enums/header-key.enum';
import { ConfigService, Endpoint } from '../../config';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RegistrationApiService {
  private readonly config = inject(ConfigService);
  private readonly http = inject(HttpClient);

  private readonly adminServiceUrl = this.config.getEndpoint(Endpoint.AdminService);

  public verifyToken(uuid: string): Observable<VerificationToken> {
    const url = `${this.adminServiceUrl}/verifications/${uuid}`;
    const headers = {
      [HeaderKey.Accept]: ContentType.VerificationToken
    };
    return this.http.get<BackEndVerificationToken>(url, { headers }).pipe(
      map(token => VerificationToken.fromBackEnd(token))
    );
  }

  public registerAdmin(credentialsId: string, password: string, verificationTokenId: string, otp: string): Observable<void> {
    const url = `${this.adminServiceUrl}/credentials/${credentialsId}/register`;
    const body = {
      otp,
      password: password,
      verification_token_id: verificationTokenId,
    };
    const headers = {
      [HeaderKey.ContentType]: ContentType.Registration
    };
    return this.http.post<void>(url, body, { headers });
  }

  public validatePassword(credentialsId: string, password: string): Observable<PasswordValidation> {
    const url = `${this.adminServiceUrl}/credentials/${credentialsId}/verify`;
    const headers = {
      [HeaderKey.ContentType]: ContentType.PasswordValidation
    };
    return this.http.post<PasswordValidation>(url, { password }, { headers });
  }
}
